import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseModal } from '@app/components/common/BaseModal/BaseModal';
import { BaseText } from '@app/components/common/BaseText/BaseText';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';

import * as S from './DeleteEntryModal.styles';

interface IProps {
  isVisible: boolean;
  isProcessing: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteEntryModal: React.FC<IProps> = ({ isVisible, isProcessing, onClose, onDelete }) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      open={isVisible}
      footer={null}
      onCancel={onClose}
      centered
      width={500}
      closable={!isProcessing}
      maskClosable={!isProcessing}
    >
      <S.BodyWrapper>
        <S.TitleWrapper>
          <BaseText color="dark" size="xxxl" weight="bold">
            {t('professionalFishers.deleteEntry')}
          </BaseText>
        </S.TitleWrapper>

        <S.InnerWrapper>
          <BaseText color="dark" size="md">
            {t('professionalFishers.deleteEntryQuestion')}
          </BaseText>
        </S.InnerWrapper>
      </S.BodyWrapper>

      <S.FooterWrapper>
        <BaseRow justify="center">
          <S.DeleteButton shape="round" htmlType="button" loading={isProcessing} onClick={onDelete}>
            {t('common.delete')}
          </S.DeleteButton>
        </BaseRow>
      </S.FooterWrapper>
    </BaseModal>
  );
};
